import ZoomifyClass, * as ZoomifyModule from './../../node_modules/ol/source/Zoomify.js';

class Zoomify extends ZoomifyClass {
    constructor(options = {}) {
        options = options || {}
        super(options);
    }
}

// Copy all named exports as static methods
for (const key in ZoomifyModule) {
    if (key !== "default") {
        Zoomify[key] = ZoomifyModule[key];
    }
}

export default Zoomify;

// Re-export ALL named exports from OL
export * from './../../node_modules/ol/source/Zoomify.js';